import type { HotelDateSelectionState } from './types';

const getMinDateForHotel = (state: HotelDateSelectionState) => state.minDate;

const getMaxDateForHotel = (state: HotelDateSelectionState) => state.maxDate;

// TODO: WOM-1214 Return checkin + 1 day if checkout ==== checkin
const getSelectedCheckOutDate = (state: HotelDateSelectionState) =>
  state.selectedCheckOut;

const getSelectedCheckInDate = (state: HotelDateSelectionState) =>
  state.selectedCheckIn;

const getSelectedCheckOutMonth = (state: HotelDateSelectionState) =>
  state.checkOutMonthDate;

const getSelectedCheckInMonth = (state: HotelDateSelectionState) =>
  state.checkInMonthDate;

const isWholeYearSelectedForHotel = (state: HotelDateSelectionState) =>
  state.wholeYear;

export default {
  getMinDateForHotel,
  getMaxDateForHotel,
  getSelectedCheckOutDate,
  getSelectedCheckInDate,
  getSelectedCheckOutMonth,
  getSelectedCheckInMonth,
  isWholeYearSelectedForHotel,
};
